import $ from 'jquery'
import 'slick-carousel'

const arrow_button_prev = `<button type="button" class="slick-prev">
		<i class="fas fa-arrow-alt-left"></i>
		<span class="screen-reader-text">Previous</span>
	</button>`

const arrow_button_next = `<button type="button" class="slick-next">
		<i class="fas fa-arrow-alt-right"></i>
		<span class="screen-reader-text">Next</span>
	</button>`

/*************** Slider ***************/
$('.hero-carousel')
	.slick({
		adaptiveHeight: true,
		arrows: true,
		//autoplaySpeed: 15000,
		autoplaySpeed: 10000,
		dots: true,
		infinite: true,
		slidesToShow: 1,
		speed: 500,
		autoplay: true,
		prevArrow: arrow_button_prev,
		nextArrow: arrow_button_next,
		responsive: [
			{
				breakpaoint: 650,
				settings: {
					arrows: false,
				},
			},
		],
	})
	.fadeIn()

/*************** Slide Gallery ***************/
$('.slide-gallery')
	.slick({
		dots: false,
		infinite: false,
		speed: 500,
		adaptiveHeight: false,
		slidesToShow: 1,
		prevArrow: arrow_button_prev,
		nextArrow: arrow_button_next,
	})
	.fadeIn()

/*************** Logo Gallery ***************/
$('.logo-gallery')
	.slick({
		dots: false,
		infinite: true,
		speed: 500,
		adaptiveHeight: false,
		slidesToShow: 4,
		autoplay: true,
		prevArrow: arrow_button_prev,
		nextArrow: arrow_button_next,
		asNavFor: '.logo-gallery',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 750,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	})
	.fadeIn()

/*************** Announcements Slider ***************/
$('.announcements__carousel')
	.slick({
		arrows: true,
		autoplaySpeed: 15000,
		dots: false,
		infinite: true,
		slidesToShow: 1,
		speed: 500,
		autoplay: false,
		prevArrow: arrow_button_prev,
		nextArrow: arrow_button_next,
		responsive: [
			{
				breakpaoint: 650,
				settings: {
					arrows: false,
				},
			},
		],
	})
	.fadeIn()
